var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSkyCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#1185FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16763 5.0385C6.31411 5.82053 7.54727 7.40616 8.00003 8.2571C8.45282 7.40622 9.68592 5.82051 10.8324 5.0385C11.6597 4.47422 13 4.03761 13 5.42692C13 5.70439 12.8249 7.75777 12.7222 8.09113C12.3653 9.25012 11.0646 9.54572 9.90759 9.36681C11.93 9.67955 12.4445 10.7155 11.3334 11.7514C9.22323 13.7188 8.30048 11.2578 8.06392 10.6271C8.02058 10.5115 8.0003 10.4575 8 10.5034C7.9997 10.4575 7.97942 10.5115 7.93607 10.6271C7.69963 11.2578 6.77689 13.7189 4.66661 11.7514C3.55551 10.7155 4.06998 9.67949 6.09241 9.36681C4.93539 9.54572 3.63467 9.25012 3.27777 8.09113C3.17508 7.75774 3 5.70435 3 5.42692C3 4.03761 4.34043 4.47422 5.16763 5.0385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSkyCircle);
export default __webpack_public_path__ + "static/media/blueSky-circle.9f878528f5e6bf9fe627d842692fea75.svg";
export { ForwardRef as ReactComponent };